import { logHelpWidgetWidgetOpen } from '../../bi/biLogger';
import { updateWidgetSession } from '../../services';
import { dispatch, onStoreEvent } from '../../store';

export const subscribeToWidgetExpansion = () => {
  let previousExpandedState = false;

  onStoreEvent('@events/widget/expanded', (_, expanded) => {
    if (expanded && !previousExpandedState) {
      updateWidgetSession({})
        .then((widgetSession) => {
          dispatch('app/setWidgetSession', widgetSession);
          logHelpWidgetWidgetOpen(widgetSession.sessionId, widgetSession.requestId);
        })
        .catch((error) => {
          console.error('Failed to log widget open event:', error);
        });
    }
    previousExpandedState = expanded;
  });
};
